import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";
import { GET_COUPON_QUERY_KEY } from "./useGetCoupon";
import { GET_COUPONS_QUERY_KEY } from "./useListCoupons";

export type AssignCouponInput = {
    couponId: string;
    userIds?: string[];
    cohortId?: string;
};

export const useAssignCoupon = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: ({ couponId, ...body }: AssignCouponInput) =>
            client.fetchApi<any, Omit<AssignCouponInput, 'couponId'>>({
                endpoint: `coupons/admin/${couponId}/assign`,
                method: 'POST',
                body,
            }),
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: GET_COUPONS_QUERY_KEY(selectedOrganization?.id || '') });
            queryClient.invalidateQueries({ queryKey: GET_COUPON_QUERY_KEY(variables.couponId) });
        },
    });
};
